
import { Component, Vue } from "vue-property-decorator"
import { State, Action } from "vuex-class"
import { BaseState } from "@/store"
import { CurrentUser, UserPreferences } from "@/types/user"
import Label from "@/components/Dashboard/Label.vue"

@Component({
	components: { Label }
})
export default class NewInterfaceSwitch extends Vue {
	@State((state: BaseState) => state.me)
	me!: CurrentUser

	@State((state: BaseState) => state.me!.preferences)
	userPreferences: UserPreferences | undefined

	@Action("updateUserPreferences")
	updatePreferences!: (prefs: UserPreferences) => Promise<void>

	get useV2 () {
		return !(!!this.userPreferences && this.userPreferences.disableV2)
	}

	set useV2 (value: boolean) {
		let newPreferences: UserPreferences = (!this.userPreferences) ? { disableV2: false } : { ...this.userPreferences }
		newPreferences.disableV2 = !value

		this.updatePreferences(newPreferences)
	}
}
